export default __webpack_public_path__ + "static/media/image.cryptonix-lanka.6e10040d.png";